import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { ApproachesTabCardIcon } from './icons'
import whiteCheckmarkImage from 'images/white-check.svg'
import classnames from 'classnames'
import { find } from 'lodash'
import { yankBy, isOtherType } from 'utils'

const propTypes = {
  approachesResources: PropTypes.arrayOf(Types.skillAllocation).isRequired,
  allApproachesTypes: PropTypes.arrayOf(Types.approach).isRequired,
  className: PropTypes.string,
}

const defaultProps = {
  className: '',
}

function approachTypeRequested(approachesResources, approachId) {
  return find(approachesResources, { approachId })
}

function ApproachesTabContent({
  approachesResources,
  className,
  allApproachesTypes,
}) {
  const [otherApproachType, definedApproachTypes] = useMemo(
    () => yankBy(allApproachesTypes, isOtherType),
    [allApproachesTypes]
  )

  const [otherDetailsActive, setOtherDetailsActive] = useState(false)
  const controlledId = `outcomes-stat-${otherApproachType?.id}`
  const otherApproachTypeRequested = approachTypeRequested(
    approachesResources,
    otherApproachType?.id
  )

  return (
    <div className={classnames('colored-block', className)}>
      {definedApproachTypes.map(({ id, displayName, name }) => {
        return (
          <div
            key={id}
            className={classnames('stat-card', 'card', {
              'none-selected': !approachTypeRequested(approachesResources, id),
            })}
          >
            <div className="stat-inner-with-image">
              <div className="image-block">
                <ApproachesTabCardIcon approachName={name} />
                <span>
                  <img src={whiteCheckmarkImage} alt="Checkmark" />
                </span>
              </div>
              <p>{displayName}</p>
            </div>
          </div>
        )
      })}
      {otherApproachType && (
        <div
          key={otherApproachType.id}
          className={classnames('stat-card', 'card', {
            'none-selected': !otherApproachTypeRequested,
            'active-trigger': otherDetailsActive,
          })}
        >
          <div className="stat-inner-with-image">
            <div className="image-block">
              <ApproachesTabCardIcon approachName={otherApproachType.name} />
              <span>
                <img src={whiteCheckmarkImage} alt="Checkmark" />
              </span>
            </div>
            <p>Other</p>
            {otherApproachTypeRequested && (
              <button
                onClick={() => setOtherDetailsActive(!otherDetailsActive)}
                className="stat-trigger"
                aria-label="Toggle Other Details"
                aria-expanded={otherDetailsActive}
                aria-controls={controlledId}
              />
            )}
          </div>
          <div id={controlledId}>
            {otherDetailsActive && (
              <div className="stat-details">
                <div className="stat-content">
                  <ul>
                    <li>{otherApproachTypeRequested.otherText}</li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

ApproachesTabContent.propTypes = propTypes
ApproachesTabContent.defaultProps = defaultProps

export default ApproachesTabContent
